<template>
  <v-data-table
    :headers="headers"
    :items="data"
    :loading="loading"
    class="elevation-0"
    :server-items-length="pagination.totalElements"
    :footer-props="{'items-per-page-options':[10, 30, 50, 100]}"
    @update:options="optionsUpdated"
  >
    <template v-slot:item.actions="{ item }">
      <v-btn
        color="primary"
        icon
        @click.stop="edit(item.id)"
      >
        <v-icon size="18">
          mdi-square-edit-outline
        </v-icon>
      </v-btn>
      <v-btn
        color="red"
        icon
        @click.stop="remove(item.id)"
      >
        <v-icon size="18">
          mdi-delete
        </v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>

export default {
  name: 'UsersList',
  props: {
    data: Array,
    loading: Boolean,
    pagination: {
      default: null
    }
  },
  data: () => ({
    headers: [
      {
        text: 'ID',
        value: 'id',
        sortable: true,
      },
      {
        text: 'Imię',
        value: 'firstName',
        sortable: true,
      },
      {
        text: 'Nazwisko',
        value: 'lastName',
        sortable: true,
      },
      {
        text: 'Email',
        value: 'email',
        sortable: true,
      },
      {
        text: 'Rola',
        value: 'role.name',
        sortable: true,
      },
      {
        text: 'RedTrain Id',
        value: 'redtrainId',
        sortable: true,
      },
      {
        text: 'Akcje',
        value: 'actions',
        sortable: false,
        align: 'right'
      },
    ],
    userToRemove: null,
    userToRemoveLoading: false,
    userToEdit: null
  }),
  methods: {
    remove(id) {
      this.$emit('remove', id)
    },
    edit(id) {
      this.$emit('edit', id)
    },
    refreshData() {
      this.$emit('fetchData')
    },
    optionsUpdated({page, itemsPerPage, sortBy, sortDesc}) {
      this.pagination.page = page
      this.pagination.perPage = itemsPerPage
      this.pagination.sortBy = sortBy[0]
      this.pagination.orderBy = sortDesc[0] ? 'desc' : 'asc'

      this.refreshData()
    },
  }
}
</script>

<style scoped>

</style>
